<template>
  <div class="field-wrapper">
    <div :class="{ 'flex items-center': inline }">
      <div :class="{ 'mb-2': !inline, 'mr-2': inline }">
        <label
          v-if="$slots.label || label"
          :for="name"
          class="block font-medium"
        >
          <slot
            v-if="$slots.label"
            name="label"
          />
          <template v-else>{{ label }}</template>
        </label>
        <p
          v-if="description"
          class="text-sm text-gray-500"
        >
          {{ description }}
        </p>
      </div>

      <!-- TODO: Check to extend `p-invalid` on children to not have to handle error styling -->
      <slot />
    </div>

    <small
      v-if="error.message || success.valid"
      class="help-message text-xs"
      :class="{
        'text-red-400': error.message,
        'text-green-600': success.valid,
      }"
    >
      {{ formatMessage(error.message ?? success.message) }}
    </small>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  name: string
  label?: string
  description?: string
  inline?: boolean
  error: {
    message?: string
  }
  success: {
    valid: boolean
    message?: string
  }
}>()

const formatMessage = (message: string) => {
  return `${message.charAt(0).toUpperCase()}${message.slice(1)}`
}
</script>

<style lang="scss">
.field-wrapper {
  position: relative;
  margin-bottom: calc(1em * 1.5);
  width: 100%;

  input,
  .p-inputnumber,
  .p-password {
    width: 100%;
  }

  .help-message {
    position: absolute;
    bottom: calc(-1.5 * 1em);
    left: 0;
    margin: 0;
  }
}
</style>
